<template>
  <ModalBase @closed="emit('closed')" ref="modal">
    <div class="wBoxCn">
      <ModalCloseModal @click="modal.close()" />
      <h2>Рассчитать стоимость</h2>
      <div class="modal-form-loader form-loader" v-if="loading">
        <IconLoader />
      </div>
      <div class="modal-form-info" v-else-if="status">
        <IconSuccess v-if="status == 1" />
        <IconError v-else />
        <p>{{ info }}</p>
      </div>
      <template v-else>
        <form class="form" @submit.prevent="submit">
          <div class="from-field">
            <input
              type="text"
              v-model="form.name.value"
              placeholder="Имя *"
              required
              maxlength="50"
              :class="{ error: form.name.classError }"
              @focus="form.name.focus"
              @blur="form.name.blur"
            />
            <p v-if="form.name.showError" class="error">
              Минимальня длина поля "Имя" 3 символа
            </p>
          </div>
          <div class="from-field">
            <input
              type="tel"
              v-model="form.phone.value"
              placeholder="Номер телефона *"
              required
              @input="checkPhoneInput"
              maxlength="18"
              :class="{ error: form.phone.classError }"
              @focus="form.phone.focus"
              @blur="form.phone.blur"
            />
            <p v-if="form.phone.showError" class="error">
              Введите номер телефона в международном формате
            </p>
          </div>
          <div class="from-field">
            <input
              type="text"
              v-model="form.avto.value"
              placeholder="Марка автомобиля *"
              required
              maxlength="50"
              :class="{ error: form.avto.classError }"
              @focus="form.avto.focus"
              @blur="form.avto.blur"
            />
            <p v-if="form.avto.showError" class="error">
              Минимальня длина поля "Марка автомобиля" 5 символов
            </p>
          </div>
          <template v-for="(o, i) in formOptions" :key="i">
            <input
              type="checkbox"
              :id="`request_service_${i}`"
              style="display: none"
              v-model="checked[i]"
            /><label class="checkbox" :for="`request_service_${i}`">{{
              o
            }}</label
            ><span class="clr"></span>
          </template>

          <UiConditionsLink v-model="accept" />
          <button
            type="submit"
            :class="{ disabled: !checking || !form.valid || !accept }"
          >
            Отправить
          </button>
        </form>
      </template>
    </div>
  </ModalBase>
</template>

<script setup>
import { inject } from "vue";
import { maskInp } from "~/helpers/format";
import { useForm, form2Body } from "~/helpers/form";
import { minLength, required } from "~/helpers/validators";
import { formServerErrorText } from "~/helpers/form";
const emit = defineEmits(["closed"]);
const modal = ref();
const formOptions = inject("formOptions");
const checked = ref([]);
const checking = computed(() => checked.value.find((k) => k));
const loading = ref();
const accept = ref(false);
const info = ref();
const status = ref();

const form = useForm({
  name: {
    value: "",
    validators: { required, minLength: minLength(3) },
  },
  phone: {
    value: "",
    validators: { required, minLength: minLength(18) },
  },
  avto: {
    value: "",
    validators: { required, minLength: minLength(5) },
  },
});

const checkPhoneInput = () => {
  form.phone.value = maskInp(form.phone.value);
};

const submit = async () => {
  if (!checking.value || !form.valid || loading.value || !accept.value) return;
  useMetrika("form");
  loading.value = true;
  const body = form2Body(form, "request");
  body.service = [];
  checked.value.forEach((c, i) => {
    if (c) body.service.push(formOptions[i]);
  });
  const res = await $fetch("/api/submit", {
    method: "POST",
    body,
  });
  loading.value = false;
  if (res?.success) {
    info.value =
      "Ваша заявка отправлена. Мы свяжемся с Вами в течение 15 минут.";
    status.value = 1;
  } else {
    info.value = formServerErrorText;
    status.value = 2;
  }
  setTimeout(() => modal.value.close(), 5000);
};
</script>
